import React from "react";
import { BabyIcon, ClipboardCheckIcon, FileTextIcon, UserPlusIcon, UsersIcon, BoxIcon } from "lucide-react";
export type ReceptionTab = 'overview' | 'register' | 'queue' | 'reports' | 'reviewDue' | 'maternity';
type ReceptionServiceCardsProps = {
  activeTab: ReceptionTab;
  onSelect: (tab: Exclude<ReceptionTab, 'overview'>) => void;
};
const cards: Array<{
  tab: Exclude<ReceptionTab, 'overview'>;
  name: string;
  caption: string;
  icon: BoxIcon;
  bg: string;
  ring: string;
}> = [{
  tab: 'register',
  name: 'Register New',
  caption: 'Add a new patient',
  icon: UserPlusIcon,
  bg: 'bg-[#221587]',
  ring: 'ring-[#221587]'
}, {
  tab: 'queue',
  name: 'Queue',
  caption: 'Patients waiting',
  icon: UsersIcon,
  bg: 'bg-[#8B2BE2]',
  ring: 'ring-[#8B2BE2]'
}, {
  tab: 'reports',
  name: 'Patient Reports',
  caption: 'Lab & radiology',
  icon: FileTextIcon,
  bg: 'bg-[#E0106F]',
  ring: 'ring-[#E0106F]'
}, {
  tab: 'reviewDue',
  name: 'Review Due',
  caption: 'Follow-up reviews',
  icon: ClipboardCheckIcon,
  bg: 'bg-[#D97706]',
  ring: 'ring-[#D97706]'
}, {
  tab: 'maternity',
  name: 'Maternity Registration',
  caption: 'Active maternity',
  icon: BabyIcon,
  bg: 'bg-[#0D9488]',
  ring: 'ring-[#0D9488]'
}];
export function ReceptionServiceCards({
  activeTab,
  onSelect
}: ReceptionServiceCardsProps) {
  return <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" data-id="element-6203" data-mp="1bbgf1y979n6m">
      {cards.map(({
      tab,
      name,
      caption,
      icon: Icon,
      bg,
      ring
    }) => {
      const isActive = activeTab === tab;
      return <button key={tab} type="button" onClick={() => onSelect(tab)} aria-pressed={isActive} className={`${bg} flex items-center gap-3 rounded-xl px-4 py-3 text-left text-white shadow-md shadow-gray-300/40 transition-transform duration-150 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-offset-2 ${ring} ${isActive ? 'ring-4 ring-offset-2 ring-offset-chrome-canvas' : ''}`} data-id="element-6204" data-mp="wlsg33ohr0m2">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/20" data-id="element-6205" data-mp="10nn0lgsbstbk">
              <Icon className="h-[18px] w-[18px] text-white" strokeWidth={2} aria-hidden="true" data-id="element-6206" data-mp="15mq9jcbffjot" />
            </span>
            <span className="min-w-0" data-id="element-6207" data-mp="19pwbi7riaoph">
              <span className="block truncate text-sm font-semibold leading-tight" data-id="element-6208" data-mp="1eoha62r410bt">
                {name}
              </span>
              <span className="block truncate text-xs text-white/85" data-id="element-6209" data-mp="hyzxh3tpme0m">
                {caption}
              </span>
            </span>
          </button>;
    })}
    </div>;
}